const defaultSize = "md";

export { defaultSize };
